import React from "react";

import {
  formatMoneyFull,
} from "../../../utils/formatters";

export default function DecisionAnalysisPanel({
  data,
  loading,
  error,
  settings,
}) {
  const currency = settings?.currency || "USD";

  const strategies =
    data?.comparison?.strategies || [];

  const recommended =
    data?.comparison?.recommended_strategy
      ?.strategy_name;

  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6 text-sm text-slate-500">
        Calculating decision analysis...
      </div>
    );
  }

  if (error && !data) {
    return (
        <div className="rounded-xl border border-red-200 bg-red-50 p-6 text-sm text-red-800">
        Unable to load the decision analysis.
        </div>
    );
    }

  if (strategies.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <h2 className="text-lg font-semibold text-slate-900">
          Decision Analysis
        </h2>

        <p className="text-sm text-slate-500 mt-1">
          No financing strategies are available for comparison.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4">
      <h2 className="text-lg font-semibold text-slate-900">
        Decision Analysis
      </h2>

      <p className="text-sm text-slate-500 mt-1">
        Compare financing strategies and identify the lowest expected financial cost.
      </p>

      <div className="overflow-x-auto mt-4">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-slate-500">
              <th className="py-2 px-3">Strategy</th>
              <th className="py-2 px-3">Premium</th>
              <th className="py-2 px-3">Limit</th>
              <th className="py-2 px-3">Transferred</th>
              <th className="py-2 px-3">Retained</th>
              <th className="py-2 px-3">Tail Exposure</th>
              <th className="py-2 px-3">Total Cost</th>
            </tr>
          </thead>

          <tbody>
            {strategies.map((strategy) => {
              const isRecommended =
                strategy.strategy_name ===
                recommended;

              return (
                <tr
                  key={strategy.strategy_name}
                  className={`border-b border-slate-100 ${
                    isRecommended
                      ? "bg-emerald-50"
                      : ""
                  }`}
                >
                  <td className="py-3 px-3 font-medium text-slate-900">
                    {strategy.strategy_name}

                    {isRecommended && (
                      <span className="ml-2 text-xs text-emerald-700 font-semibold">
                        Recommended
                      </span>
                    )}
                  </td>

                  <td className="py-3 px-3">
                    {formatMoneyFull(
                      strategy.premium,
                      currency
                    )}
                  </td>

                  <td className="py-3 px-3">
                    {formatMoneyFull(
                      strategy.policy_limit,
                      currency
                    )}
                  </td>

                  <td className="py-3 px-3">
                    {formatMoneyFull(
                      strategy.transferred_loss,
                      currency
                    )}
                  </td>

                  <td className="py-3 px-3">
                    {formatMoneyFull(
                      strategy.retained_loss,
                      currency
                    )}
                  </td>

                  <td className="py-3 px-3">
                    {formatMoneyFull(
                      strategy.tail_exposure,
                      currency
                    )}
                  </td>

                  <td className="py-3 px-3 font-semibold">
                    {formatMoneyFull(
                      strategy.total_financing_cost,
                      currency
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}